<template>
    <div>
        <el-dialog
            title="交易明细对账单导出"
            :visible.sync="visible"
            @closed="handleCancel"
            width="60%"
        >
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="导出数据" name="query">
                    <div class="tab-item">
                        <div class="title">查询条件</div>
                        <div class="content">
                            <el-tag class="query-item" type="info"  v-for="(item,index) in query" :key="index">
                                {{ `${item.name}: ${item.value}` }}
                            </el-tag>
                        </div>
                    </div>
                    <div class="tab-item">
                        <div class="title">导出说明</div>
                        <div class="text-content">
                            <div class="text">1、数据处理根据导出的数据条数，可能需要处理几分钟到半小时不等，操作导出后， 可通过【查询导出结果】查看导出结果；</div>
                            <div class="text">2、数据处理完成后生成的文件，将为您保存7天，在此期间您可以将文件下载到电脑本地</div>
                        </div>
                    </div>
                    <div class="footer">
                        <el-button @click="handleCancel">取消</el-button>
                        <el-button
                            type="primary"
                            v-if="showExportBtn"
                            @click="handleExport"
                        >
                        立即导出
                        </el-button>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="查询导出结果" name="list">
                    <div class="export-tips">数据处理成功后，导出记录及下载入口会保留7天，请及时下载</div>
                    <el-table :data="tableData" v-loading="tableLoading">
                        <el-table-column prop="exportTime" align="center" label="导出时间"></el-table-column>
                        <el-table-column prop="condition" align="center" label="查询条件"></el-table-column>
                        <el-table-column prop="processStatus" align="center" label="数据处理状态"></el-table-column>
                        <el-table-column align="center" prop="set" label="操作">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="scope.row.processStatus === '已处理'"
                                    type="text"
                                    size="small"
                                    @click.stop="downloadFile(scope.row)"
                                >下载文件</el-button>
                                <span v-else>--</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        style="padding: 16px; text-align: right"
                        layout='total,sizes,prev,pager,next,jumper'
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pagination.currentPage"
                        :page-sizes="[10, 20, 30, 40, 50]"
                        :page-size="pagination.pagesize"
                        :total="pagination.total"
                    ></el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import { omit } from 'lodash'
import { exportList, getExportResult, downloadExportFile } from '@/api/domain/finance'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      visible: false,
      tableLoading: false,
      activeName: 'query',
      query: [
        {
          name: '清分渠道',
          key: 'bankChannelName',
          value: '--',
        },
        {
          name: '交易ID',
          key: 'transactionId',
          value: '--',
        },
        {
          name: '付款账户',
          key: 'transferorName',
          value: '--',
        },
        {
          name: '付款账户',
          key: 'receiverName',
          value: '--',
        },
        {
          name: '交易类型',
          key: 'transactionTypeName',
          value: '--',
        },
        {
          name: '交易时间',
          key: 'transactionTime',
          value: '--',
        },
      ],
      queryParams: {},
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    ...mapGetters(['bankChannelType']),
    showExportBtn() {
      return this.checkBankChannelPermission('trade_export_now', 'trade_export_now_wangshang', this.bankChannelType)
    },
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    showDialog(queryParams = {}) {
      // eslint-disable-next-line no-return-assign
      this.query.forEach((item) => item.value = '--')
      const [startTime = null, endTime = null] = queryParams.transactionTime

      this.queryParams = {
        ...queryParams,
        startTime,
        endTime,
      }

      this.query.forEach((item) => {
        Object.keys(this.queryParams).forEach((key) => {
          if (item.key === 'transactionTime') {
            if (!this.queryParams.startTime && !this.queryParams.endTime) {
              item.value = '--'
            } else {
              item.value = `${moment(this.queryParams.startTime).format('YYYY-MM-DD HH:mm:ss')} 
                                至 
                                ${moment(this.queryParams.endTime).format('YYYY-MM-DD HH:mm:ss')}`
            }
          }

          if (item.key === key && this.queryParams[key]) {
            item.value = this.queryParams[key]
          }
        })
      })

      this.visible = true
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleClick() {
      this.pagination.currentPage = 1
      if (this.activeName === 'list') this.getExportList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleCancel() {
      this.visible = false
      this.activeName = 'query'
    },
    // eslint-disable-next-line vue/no-unused-properties
    async handleExport() {
      const { code } = await exportList({
        ...omit(this.queryParams, ['transactionTime', 'transactionTypeName', 'bankChannelName']),
        channelType: this.bankChannelType,
      })
      if (code === 1) {
        this.$message.success('导出中，请稍后在【查询导出结果】中查看')
        this.activeName = 'list'
        this.getExportList()
      }
    },
    async getExportList() {
      this.tableLoading = true
      const { code, data } = await getExportResult({
        channelType: this.bankChannelType,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
      })
      this.tableLoading = false
      if (code === 1) {
        this.tableData = data.items?.map((item) => {
          return {
            ...item,
            processStatus: item.processStatus === 0 ? '处理中' : '已处理',
          }
        }) || []
        this.pagination.total = data.totalNum
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    async downloadFile(row) {
      const data = await downloadExportFile({
        exportId: row.exportId,
      })

      if (data.size > 0) {
        const url = window.URL.createObjectURL(
          new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          }),
        )
        const link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', row.fileName)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        this.$message.error('文件下载链接已过期，请重新导出')
      }
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getExportList()
    },
    // eslint-disable-next-line vue/no-unused-properties
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getExportList()
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-item {
    display: flex;
    margin-bottom: 10px;
    .title {
        flex-basis: 62px;
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
    }
    .content {
        .query-item {
            margin: 0 10px 5px 0;
        }
    }
    .text-content {
        .text {
            font-size: 12px;
            margin-bottom: 5px;
        }
    }
}
.export-tips {
    font-size: 14px;
    color: red;
    margin-bottom: 10px;
}
.footer {
    text-align: center;
}
</style>
